import { render } from "./ScrollTop.vue?vue&type=template&id=0e3dd5ac&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=0e3dd5ac&scoped=true&lang=css"

import exportComponent from "D:\\Clouds\\Programacion\\Vue\\words-search\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3dd5ac"]])

export default __exports__